/* ══════════════════════════════════════════════════════════════════
   通用页面零件的运行时。只有两个零件需要 JS：

     · hotspot —— 开合小卡、靠边翻边（**只在桌面**：手机上点位落回文档流，
       排成图下面一列卡片，那是纯 CSS 的，不欠脚本）
     · video   —— 点了才把 iframe 放进来（第三方 cookie 在点之前不该写下去）

   折叠问答不在这里：它是原生 <details>，没有 JS 也能开。

   **全部用事件委托挂在 document 上** —— 零件是运营在编辑器里现加的，
   页面加载时数一遍 DOM 的写法，加一个块就得刷新一次才活。

   视频「点了才加载」那一段**已经搬走了** —— 它和产品页的故事、评测墙
   本来是三份一样的实现，2026-08-06 合成 `component-video.js`。
   契约（`data-video` / `data-video-type` / `[data-play]`）没有变，
   凡是用到 video 块的 section 都要同时引 `component-video.js`。
   ══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var PHONE = '(max-width: 768px)';

  /* ── hotspot ─────────────────────────────────────────────── */

  function closeAll(root) {
    (root || document).querySelectorAll('.eb-hot__pin.is-open').forEach(function (pin) {
      pin.classList.remove('is-open');
      var dot = pin.querySelector('.eb-hot__dot');
      if (dot) dot.setAttribute('aria-expanded', 'false');
    });
  }

  /* 靠边就翻边。量的是**小卡自己的位置**，不是点位的百分比 ——
     百分比只知道点在图的哪儿，不知道卡有多宽。 */
  function place(pin) {
    var pop = pin.querySelector('.eb-hot__pop');
    var stage = pin.closest('.eb-hot__stage');
    if (!pop || !stage) return;
    pin.removeAttribute('data-flip-x');
    pin.removeAttribute('data-flip-y');
    var s = stage.getBoundingClientRect();
    var p = pop.getBoundingClientRect();
    if (p.right > s.right - 4) pin.setAttribute('data-flip-x', '');
    if (p.top < s.top + 4) pin.setAttribute('data-flip-y', '');
  }

  document.addEventListener('click', function (e) {
    var dot = e.target.closest('.eb-hot__dot');
    if (dot) {
      e.preventDefault();
      /* 手机上卡片本来就摊开着，点圆点没有东西可开 */
      if (window.matchMedia(PHONE).matches) return;
      var pin = dot.closest('.eb-hot__pin');
      var wasOpen = pin.classList.contains('is-open');
      closeAll(pin.closest('.eb-hot'));
      if (wasOpen) return;
      pin.classList.add('is-open');
      dot.setAttribute('aria-expanded', 'true');
      place(pin);
      return;
    }
    /* 点到卡片以外的地方就收起来。点在卡片里不算 —— 卡里有链接。 */
    if (!e.target.closest('.eb-hot__pop')) closeAll();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });

  window.addEventListener('resize', function () {
    document.querySelectorAll('.eb-hot__pin.is-open').forEach(place);
  });

  /* ── countdown：走秒 ─────────────────────────────────────────
     时间在这儿算，不在 Liquid 里算 —— Liquid 算的是页面被缓存那一刻。
     到点整块消失，或者换成运营写的那句话；不显示一排 0。 */

  function tick(box) {
    var end = Date.parse((box.dataset.countdown || '').trim().replace(' ', 'T')
      + (box.dataset.countdownTz || ''));
    if (isNaN(end)) return true;

    var left = end - Date.now();
    if (left <= 0) {
      var msg = box.dataset.countdownExpired;
      if (msg) {
        box.textContent = msg;
        box.className = 'eb-countdown__over';
      } else {
        box.hidden = true;
      }
      return true;
    }

    var s = Math.floor(left / 1000);
    var set = function (key, value) {
      var el = box.querySelector('[data-countdown-' + key + ']');
      if (el) el.textContent = value < 10 ? '0' + value : String(value);
    };
    set('days', Math.floor(s / 86400));
    set('hours', Math.floor(s % 86400 / 3600));
    set('minutes', Math.floor(s % 3600 / 60));
    set('seconds', s % 60);
    return false;
  }

  function startCountdowns() {
    document.querySelectorAll('[data-countdown]:not([data-ticking])').forEach(function (box) {
      box.setAttribute('data-ticking', '1');
      if (tick(box)) return;
      var timer = setInterval(function () {
        if (tick(box)) clearInterval(timer);
      }, 1000);
    });
  }
  startCountdowns();
  document.addEventListener('shopify:section:load', startCountdowns);

  /* ── FAQ 的结构化数据 ────────────────────────────────────────
     一页只出一份 FAQPage，从**已经渲染好的折叠**里拼。

     为什么不在 Liquid 里出：问题和答案在 theme block 的设置里，
     而 section 读不到子块的设置（README §十六 规矩 3），拼不出那份 JSON。
     Google 会渲染 JS，所以这份认得，但比服务端直接吐出来低一档 ——
     哪天这条 SEO 比「块能复用」更重要，就把 FAQ 改成本地 block。 */

  function faqSchema() {
    var items = document.querySelectorAll('.eb-faqsec__list .eb-faq');
    if (!items.length || document.getElementById('eb-faq-schema')) return;

    var entities = [];
    items.forEach(function (faq) {
      var q = faq.querySelector('.eb-faq__q');
      var a = faq.querySelector('.eb-faq__a');
      if (!q || !a) return;
      /* summary 里还有那个 + 图标，取文字的时候要把它排除掉 */
      var icon = q.querySelector('.eb-faq__ic');
      var question = (icon ? q.textContent.replace(icon.textContent, '') : q.textContent).trim();
      if (!question) return;
      entities.push({
        '@type': 'Question',
        name: question,
        acceptedAnswer: { '@type': 'Answer', text: a.textContent.trim() }
      });
    });
    if (!entities.length) return;

    var tag = document.createElement('script');
    tag.type = 'application/ld+json';
    tag.id = 'eb-faq-schema';
    tag.textContent = JSON.stringify({
      '@context': 'https://schema.org', '@type': 'FAQPage', mainEntity: entities
    });
    document.head.appendChild(tag);
  }
  faqSchema();

  /* video 的「点了才加载」在 component-video.js —— 全站一份，
     零件套件、产品页故事、评测墙共用。这里以前有一份自己的实现。 */
})();
